import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { DialogContentText, Paper } from "@mui/material";
import TkLoadingIcon from "../TkLoadingIcon";
import { useConcatRoutes } from "../../../routes/router";
import {
  API_REQUEST_END,
  API_REQUEST_START,
  ApiRequestDetail,
} from "../../../services/api";
import "./_style.scss";

const TkApiMask = (): JSX.Element | null => {
  const [isMaskVisible, setIsMaskVisible] = useState(false);
  const [isRet005Request, setIsRet005Request] = useState(false);
  const requestCountRef = useRef(0); // 今行っているAPIリクエストの数
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null); // タイマーリファレンス
  const ret005TimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const location = useLocation();
  const path = location.pathname;
  const systemRoute = useConcatRoutes();

  //　エラー画面に遷移する時にマスクを非表示にするための処理
  useEffect(() => {
    const nowRoute = systemRoute.find((r) => r.path === path);
    if (nowRoute?.meta?.isErrorPage) {
      setIsMaskVisible(false);
      setIsRet005Request(false);
      requestCountRef.current = 0;
      if (ret005TimerRef.current) {
        clearTimeout(ret005TimerRef.current);
        ret005TimerRef.current = null;
      }
    }
  }, [path, systemRoute]);

  useEffect(() => {
    const handleApiRequestStart = (e: Event) => {
      requestCountRef.current += 1;

      // リクエスト数が 1 の場合、タイマーをリセットしてマスクを表示
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      setIsMaskVisible(true);

      // /JOB35/updateがリクエストされている場合、3秒後に案内を表示
      const detail = (e as CustomEvent<ApiRequestDetail>).detail;
      if (detail?.isRet005) {
        if (ret005TimerRef.current) {
          clearTimeout(ret005TimerRef.current);
          ret005TimerRef.current = null;
        }
        ret005TimerRef.current = setTimeout(() => {
          setIsRet005Request(true);
        }, 3000);
      } else {
        if (ret005TimerRef.current) {
          clearTimeout(ret005TimerRef.current);
          ret005TimerRef.current = null;
        }
        setIsRet005Request(false);
      }
    };

    const handleApiRequestEnd = () => {
      requestCountRef.current = Math.max(0, requestCountRef.current - 1);

      if (requestCountRef.current === 0) {
        // 全てのリクエストが終了した場合、一定時間後にマスクを非表示にする
        const minimumVisibleTime = 300;
        timerRef.current = setTimeout(() => {
          if (ret005TimerRef.current) {
            clearTimeout(ret005TimerRef.current);
            ret005TimerRef.current = null;
          }
          setIsRet005Request(false);
          setIsMaskVisible(false);
        }, minimumVisibleTime);
      }
    };

    window.addEventListener(API_REQUEST_START, handleApiRequestStart);
    window.addEventListener(API_REQUEST_END, handleApiRequestEnd);

    return () => {
      window.removeEventListener(API_REQUEST_START, handleApiRequestStart);
      window.removeEventListener(API_REQUEST_END, handleApiRequestEnd);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      if (ret005TimerRef.current) {
        clearTimeout(ret005TimerRef.current);
      }
    };
  }, []);

  return isMaskVisible ? (
    <div className="tkApiMask" aria-busy={true}>
      {isRet005Request ? (
        <Paper className="ret005Info">
          <TkLoadingIcon />
          <DialogContentText>
            {`添付ファイルのサイズが大きいため、処理に時間がかかっています。\n画面を閉じずにしばらくお待ちください。`}
          </DialogContentText>
        </Paper>
      ) : (
        <TkLoadingIcon />
      )}
    </div>
  ) : null;
};

export default TkApiMask;
